export const exploreSaveStatusSelector = state => state.exploreSaveStatus;
export const setExploreSaveStatusSelector = state => state.setExploreSaveStatus;
export const resetExploreSaveStatusSelector = state => state.resetExploreSaveStatus;
export const exploreLeaveGuardSelector = state => state.exploreLeaveGuard;
export const setExploreLeaveGuardSelector = state => state.setExploreLeaveGuard;
